$(document).ready(function(){
  
    setTimeout(function() {
        $('.swatch-element.available.in0 label').click();
        $('.swatch-element.available.in0 label').trigger('click');
    },50);
  var current_fs, next_fs, previous_fs; //fieldsets
  var opacity;
  var current = 1;
  var steps = $("fieldset").length;
  setProgressBar(current);
  
  $(".next").click(function(){
    current_fs = $(this).parent();
    next_fs = $(this).parent().next();
      //Add Class Active
    $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");
      //show the next fieldset
    next_fs.show();
    //hide the current fieldset with style
    current_fs.animate({opacity: 0}, {
      step: function(now) {
      // for making fielset appear animation
      opacity = 1 - now;
      current_fs.css({
      'display': 'none',
      'position': 'relative'
      });
      next_fs.css({'opacity': opacity});
      },
      duration: 500
    });
    setProgressBar(++current);
    $(window).scrollTop(0);
  });
  
  $(".previous").click(function(){
    current_fs = $(this).parent();
    previous_fs = $(this).parent().prev();
    
    //Remove class active
    $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
    
    //show the previous fieldset
    previous_fs.show();
    
    //hide the current fieldset with style
    current_fs.animate({opacity: 0}, {
    step: function(now) {
      // for making fielset appear animation
      opacity = 1 - now;
      current_fs.css({
      'display': 'none',
      'position': 'relative'
      });
      previous_fs.css({'opacity': opacity});
    },
    duration: 500
    });
    setProgressBar(--current);

    var i = parseInt($(this).attr('index'));
    if (i == 1) {
      $('div#initial-bundle-view').fadeIn();
    $('div#start-selection').hide();      
    }
    $(window).scrollTop(0);
  });
  
  function setProgressBar(curStep){
    var percent = parseFloat(100 / steps) * curStep;
    percent = percent.toFixed();
    $(".progress-bar").css("width",percent+"%")
  }
  
  $(".submit").click(function(){
    return false;
  });

  $('button.btn.start-selection').click(function(e) {
    e.preventDefault();
    $('div#initial-bundle-view').hide();
    $('div#start-selection').fadeIn();
    // $('.index-1-ref').trigger('click');
  });

  $('.product-photo-container.owl-carousel').owlCarousel({
      loop: true,
      items: 1,
      dots: true,
      autoplay: false,
      nav: true,
      URLhashListener:true,
      autoplayHoverPause:true,
      startPosition: 'URLHash'
  });
  
  $('.index-ref .readmore').click(function (event) {
    event.preventDefault();
    $(this).parents('.index-ref').find('.product-description-full').show();
    $(this).parents('.index-ref').find('.product-description-short').hide();
  });

});
